import React from "react";
import { Link } from "react-router-dom";
import avatar1png from "../../../../assets/images/avatar-1.png";
import Shared from "../../../../components/ReUseAbleComponents/Shared";

function TicketSystem(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 bg-grey-6">
        <div className="container">
          <div className="row align-items-center justify-content-between vertical-gap mnt-30 sm-gap mb-50">
            <div className="col-auto">
              <h2 className="h4 mb-0 mt-0">Your Tickets</h2>
            </div>
            <div className="col pl-30 pr-30 d-none d-sm-block">
              <div className="dx-separator ml-10 mr-10"></div>
            </div>
            <div className="col-auto">
              <Link to="/ticket-submit" className="dx-btn dx-btn-md">
                Submit a ticket
              </Link>
            </div>
          </div>
          <Link
            to="/single-ticket"
            className="dx-ticket-item dx-ticket-new dx-ticket-open dx-block-decorated"
          >
            <span className="dx-ticket-img">
              <img src={avatar1png} alt="" />
            </span>
            <span className="dx-ticket-cont">
              <span className="dx-ticket-name"> John Leonard </span>
              <span className="dx-ticket-title h5">
                {" "}
                Need help with customization. Some options are not appearing...{" "}
              </span>
              <ul className="dx-ticket-info">
                <li>Update: 5 Nov 2018</li>
                <li>Product: Quantial</li>
                <li>Comments: 2</li>
                <li className="dx-ticket-new">New</li>
              </ul>
            </span>
            <span className="dx-ticket-status"> Open </span>
          </Link>
          <Link
            to="/single-ticket"
            className="dx-ticket-item dx-ticket-closed dx-block-decorated"
          >
            <span className="dx-ticket-img">
              <img src={avatar1png} alt="" />
            </span>
            <span className="dx-ticket-cont">
              <span className="dx-ticket-name"> Bruno Rice </span>
              <span className="dx-ticket-title h5">
                {" "}
                Theme not updating in downloads{" "}
              </span>
              <ul className="dx-ticket-info">
                <li>Update: 4 Nov 2018</li>
                <li>Product: Sensific</li>
                <li>Comments: 11</li>
              </ul>
            </span>
            <span className="dx-ticket-status"> Closed </span>
          </Link>
        </div>
      </div>
      <div className="dx-separator"></div>
      <div className="dx-box-5 pb-100">
        <div className="container mt-4 mnb-7">
          <div className="row align-items-center justify-content-between vertical-gap mnt-30 sm-gap mb-50">
            <h2 className="col-auto h4 mb-0 mt-0">Featured Articles</h2>
            <div className="col pl-30 pr-30 d-none d-sm-block">
              <div className="dx-separator ml-10 mr-10"></div>
            </div>
            <div className="col-auto dx-slider-arrows-clone"></div>
          </div>

          <div
            className="swiper-container dx-slider dx-slider-arrows dx-slider-articles"
            data-swiper-speed="400"
            data-swiper-space="50"
            data-swiper-slides="3"
            data-swiper-breakpoints="true"
            data-swiper-arrows="true"
            data-swiper-arrows-clone="true"
            data-swiper-loop="true"
            data-swiper-autoHeight="true"
            data-swiper-grabCursor="true"
          >
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="dx-article dx-article-block">
                  <h4 className="h6 dx-article-title">
                    <Link to="/single-article">
                      Make menu dropdown working without JavaScript
                    </Link>
                  </h4>
                  <div className="dx-article-text">
                    <p className="mb-0">
                      Meat all together sea deep isn&#39;t replenish called. One
                      moved cattle bring. Can&#39;t of. Itself After shall hath
                      winged. Given stars second whose yielding fourth. Subdue
                      years form saw. Second...
                    </p>
                  </div>
                  <Link
                    to="/single-article"
                    className="dx-btn dx-btn-link d-flex dx-article-link"
                  >
                    Read More <span className="icon pe-7s-angle-right"></span>
                  </Link>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="dx-article dx-article-block">
                  <h4 className="h6 dx-article-title">
                    <Link to="/single-article">Google Analytics</Link>
                  </h4>
                  <div className="dx-article-text">
                    <p className="mb-0">
                      Likeness seed he may. Brought firmament won&#39;t that to.
                      Fowl thing saw behold earth land evening gathering hath
                      after all whales winged. Greater so all two dry. Appear
                      seas fruit...
                    </p>
                  </div>
                  <Link
                    to="/single-article"
                    className="dx-btn dx-btn-link d-flex dx-article-link"
                  >
                    Read More <span className="icon pe-7s-angle-right"></span>
                  </Link>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="dx-article dx-article-block">
                  <h4 className="h6 dx-article-title">
                    <Link to="/single-article">
                      How to manually import Demo data (if you faced with
                      problems in one-click demo import)
                    </Link>
                  </h4>
                  <div className="dx-article-text">
                    <p className="mb-0">
                      And have make, isn&#39;t land herb good lesser won&#39;t.
                      Own. Us. Moveth, divided female their won&#39;t subdue
                      seas tree creepeth They&#39;re morning isn&#39;t let so
                      lights. Sixth, first every night...
                    </p>
                  </div>
                  <Link
                    to="/single-article"
                    className="dx-btn dx-btn-link d-flex dx-article-link"
                  >
                    Read More <span className="icon pe-7s-angle-right"></span>
                  </Link>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="dx-article dx-article-block">
                  <h4 className="h6 dx-article-title">
                    <Link to="/single-article">WordPress Themes FAQ</Link>
                  </h4>
                  <div className="dx-article-text">
                    <p className="mb-0">
                      Us sixth she&#39;d, which creeping fruitful winged. To
                      called made seas of grass creature good upon. Air multiply
                      gathering female saying our set creepeth wherein hath
                      waters from midst man...
                    </p>
                  </div>
                  <Link
                    to="/single-article"
                    className="dx-btn dx-btn-link d-flex dx-article-link"
                  >
                    Read More <span className="icon pe-7s-angle-right"></span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="swiper-button-prev">
              <span className="icon pe-7s-angle-left"></span>
            </div>
            <div className="swiper-button-next">
              <span className="icon pe-7s-angle-right"></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TicketSystem;
